const HEX_REGEX = /^#+([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/i;

function isValidHexString(hexString) {
    return HEX_REGEX.test(hexString);
}

export default { isValidHexString };
